import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_COMPANY_LOGO } from "../../../common/URLs";


export const addEmployerLogo = async (formData) => {
  try {
    const token = await fetchToken()
    
    const response = await fetch(`${BASE_URL}/${EMPLOYER}/${EMPLOYER_COMPANY_LOGO}`, {
      method: "POST",
      body: formData,
      headers: {
        // "Content-Type": "multipart/form-data", // Required for file uploads
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to upload logo");
    }

    const data = await response.json();
    return data; // Return the uploaded logo data (e.g., URL, ID, etc.)
  } catch (error) {
    throw new Error(error.message);
  }
};
